(function() {
'use strict';

angular
    .module('dashboard')
    .controller('DashboardReview', DashboardReview);

function DashboardReview($q,
    $location,
    $routeParams,
    dashboardService,
    dashboardReviewService,
    dashboardBookingService,
    preferences,
    dateUtil,
    imageService,
    reviewService,
    scrollService,
    broker,
    action,
    resourceService,
    mybTrack,
    currentUser
) {
    const cm = this;
    cm.bookingReviewStatus = {
        CannotLeaveReview: 0,
        CanLeaveReview: 1,
        HasLeftReview: 2
    };
    cm.showMoreReviews = showMoreReviews;
    cm.getRatingTitleText = getRatingTitleText;
    cm.saveReview = saveReview;
    cm.editReview = dashboardReviewService.editReview;
    cm.ratingRange = dashboardReviewService.ratingRange;
    cm.sutabilityAnswers = dashboardReviewService.sutabilityAnswers;
    cm.recommendTRPAnswers = dashboardReviewService.recommendTRPAnswers;
    cm.recommendTRPChange = dashboardReviewService.recommendTRPChange;
    cm.reviewLater = reviewLater;
    cm.reviews = [];
    cm.limitToNumber = 10;
    cm.reviewsPage = 0; //--for client pagination
    cm.loadingReviews = true;
    cm.loadingHotelReviews = true;
    cm.reviewsVisibleCount = 0;
    cm.sortOptions = dashboardReviewService.getReviewSortCriteria();
    cm.getResourceValue = resource => resourceService.get(resource);
    cm.showBookingBreadcrumb = 'review-hotel' === action;
    cm.bookingType = dashboardBookingService.getBookingTypeMap();
    cm.hideHotelHeader = true;

    if (action !== 'review-submitted') {
        mybTrack.track('MYB - My Reviews');
        let urlSource = $location.search().source ? $location.search().source : 'MYB';
        if (!($routeParams.userId && $routeParams.token && urlSource === 'MYB')) {
            // the extra condition is a work around, because url from email reloads the page twice,
            // so to ignore the tracking in second reload, using this condition, Will remove the condition when the reloading issue is fixed
            mybTrack.track('HotelReviewForm Landing', { source: urlSource });
        }
    }

    $q.all([dashboardReviewService.getRatingTitles(), dashboardReviewService.getStatements()]).then(function() {
        cm.reviewEnable = true;
        let objectId = $routeParams.objectId;

        if (action === 'review-hotel') {
            //not great but we want to follow a slightly different path if we are doing a non authenticated booking

            if ($routeParams.bookingId && $routeParams.userId && $routeParams.token) {
                //we need to have a booking id, user id and token
                _checkEnterReviewPage($routeParams.bookingId, $routeParams.token, $routeParams.userId);
                $location.search({});
                cm.showBookingBreadcrumb = false;
            } else {
                _checkEnterReviewPage($routeParams.bookingId, null, null);
            }
        } else if (action === 'review-submitted' && !objectId) {
                dashboardBookingService.getBookingInfo($routeParams.bookingId).then(function(bk) {
                    if (bk.Type === cm.bookingType.accommodation) {
                        _reviewPageFactory(bk.ObjectId, $routeParams.bookingId, null, null);
                    } else {
                        cm.reviewStatus = cm.bookingReviewStatus.CannotLeaveReview;
                        cm.notHotelBooking = true;
                    }
                });
        } else {
            _reviewPageFactory(objectId, $routeParams.bookingId, null, null);
        }
    });

    //for default sort by likes
    cm.sortoption = cm.sortOptions[1].val;
    cm.showUnreviewedHotels = true;
    cm.reviewNow = reviewNow;
    cm.cancelReview = cancelReview;
    cm.selectVisitedHotel = selectVisitedHotel;

    function _reviewPageFactory(objectId, bookingId) {
        let user = currentUser.get();
        if (action === 'review-submitted') {
            _prepareReviewCompletePage(bookingId, objectId);
        } else if (user && user.HardSignedIn) {
            _processDashboardAggregateData();
        } else {
            _errorCallback();
        }
    }

    function _errorCallback() {
        cm.loadingReviews = false;
        cm.reviewsLoadError = true;
    }

    function _checkEnterReviewPage(bookingId, token, userId) {
        const dim = TRPCONFIG.DeviceSettings.LandingImageHeight;

        let processData = data => {
            //do some checks to make sure the review hasn't already been submitted / they can leave a review

            let getSelectedHotelInfo = reviewData => {
                let estabId = reviewData.EstabId;

                return dashboardService.getHotelsById([estabId]).then(hotels => {
                    return {
                        EstablishmentDetail: hotels[0],
                        ImageUrl: imageService.getMainImageUrl(estabId, dim, dim),
                        BookingDetail: {
                            StartDate: reviewData.CheckInDate,
                            BookingRef: reviewData.BookingRef,
                            BookingId: bookingId,
                            LeadPassengerContact: {
                                Title: reviewData.LeadContact.Title,
                                FirstName: reviewData.LeadContact.FirstName,
                                Surname: reviewData.LeadContact.LastName
                            }
                        },
                        reviewSaved: false
                    };
                });
            };

            let status = data.ReviewStatus;
            if (status === reviewService.reviewStatus.CanLeaveReview) {
                getSelectedHotelInfo(data).then(selectedHotel => {
                   cm.selectedHotel = selectedHotel;
                    cm.feedback = dashboardReviewService.getBookingFeedback();
                    cm.hideHotelHeader = false;
                });
            } else if (status === reviewService.reviewStatus.HasLeftReview) {
                let user = currentUser.get();
                if (user && user.SignedIn) {
                    $q.all([
                        dashboardReviewService.getReview(bookingId),
                        getSelectedHotelInfo(data)
                    ]).then(results => {
                        cm.existingReview = results[0];
                        cm.selectedHotel = results[1];
                        cm.hideHotelHeader = false;
                    });
                }
            }
            cm.reviewStatus = status;
        };

        //we need to make different calls depending on what params we have
        if (token && userId) {
            reviewService.getReviewDetailsUsingToken(bookingId, token, userId).then(d => processData(d));
        } else {
            reviewService.getReviewDetails(bookingId).then(d => processData(d));
        }
    }

    function _prepareReviewHeader(bookingId, objectId) {
        dashboardReviewService.getReviewHeaderData(bookingId, objectId).then(function(result) {
            cm.loadingReviewHeader = false;
            cm.selectedHotel = result;
            if (!cm.selectedHotel.EstablishmentDetail) {
                $location.path('dashboard/reviews');
            }
        });
    }

    function _processDashboardAggregateData() {
        dashboardService.getAggregate().then(function(result) {
            _splitByReviewed(result);
            cm.reviewsVisibleCount = ((cm.reviews.length / cm.limitToNumber) > 1 ? cm.limitToNumber : cm.reviews.length);
            _prepareMyReviewPageData(cm.unreviewedHotels[0]);
        }, _errorCallback);
    }

    function _prepareMyReviewPageData(unreviewedHotel) {
        if (unreviewedHotel) {
            _canShowUnreviewedHotels().then(result => {
                cm.loadingReviews = false;
                cm.showUnreviewedHotels = result;
                cm.selectedHotel = unreviewedHotel;
                cm.selectedHotel.BookingDetail.BookingRef = `${cm.selectedHotel.BookingDetail.BookingType}/${cm.selectedHotel.BookingDetail.BookingId}`;
                cm.feedback = dashboardReviewService.getBookingFeedback();
                cm.selectedHotelIndex = 0;
                cm.reviewStatus = cm.bookingReviewStatus.CanLeaveReview;
                cm.reviewLaterEnable = true;
                cm.hideHotelHeader = false;
            }, _errorCallback);
        } else {
            cm.loadingReviews = false;
        }
    }

    function _prepareReviewCompletePage(bookingId, objectId) {
        if (bookingId) {
            //get review site details
            dashboardReviewService.getReviewSiteDetails(bookingId).then(function(result) {
                cm.reviewSiteDetails = result;
                cm.reviewSiteDetails.Image = `/build/img/otherlogo${result.Image.substr(result.Image.lastIndexOf('/'))}`;
            });

            if (objectId) {
                _prepareReviewHeader(bookingId, objectId);

                reviewService.getReviews({ Id: objectId }, 0).then(function(result) {
                    cm.hotelReviews = result.reviews;
                    cm.loadingHotelReviews = false;
                });
            }
        }
    }

    function saveReview() {
        dashboardReviewService.saveReview(cm.selectedHotel, cm.feedback, $routeParams.token, $routeParams.userId)
        .then(function(result) {
            if (result) {
                broker.publish('reviewEntered');
                mybTrack.track('MYB - Review submitted', { UserRating: cm.feedback.rating });
                //goto submitted review page
                $location.path(`dashboard/reviews/submitted/${cm.selectedHotel.BookingDetail.BookingId}/${cm.selectedHotel.EstablishmentDetail.Id}`);
            } else {
                scrollService.scrollTo('#reviews-container');
            }
        });
    }

    function _splitByReviewed(aggregate) {
        //Reviewed Hotels
        cm.reviews = aggregate.reviews;
        cm.ReviewAggregates = {
            TotalReviews: cm.reviews.length,
            TotalLikeCount: countLikes()
        };

        //Unreviewed Hotels
        aggregate.estabs.UnreviewedHotels.sort(_dateSortReview);
        cm.unreviewedHotels = angular.copy(aggregate.estabs.UnreviewedHotels);
        cm.reviewedHotels = angular.copy(aggregate.estabs.ReviewedHotels);
    }

    function _dateSortReview(a, b) {
        const aDate = new Date(a.BookingDetail.EndDate);
        const bDate = new Date(b.BookingDetail.EndDate);

        return aDate >= bDate ? -1 : aDate < bDate ? 1 : 0;
    }

    function countLikes() {
        let likeCount = 0;
        angular.forEach(cm.reviews, function(review) {
            likeCount += review.LikeCount;
        });
        return likeCount;
    }

    function showMoreReviews() {
        cm.reviewsPage += 1;
        const count = cm.limitToNumber * (cm.reviewsPage + 1);
        cm.reviewsVisibleCount = ((cm.reviews.length / count) > 1 ? (count) : cm.reviews.length);
    }

    function getRatingTitleText(n) {
        return dashboardReviewService.getRatingTitleText(n);
    }

    function _canShowUnreviewedHotels() {
        return preferences.get('reviewReminder').then(function(reminderDate) {
            return !(reminderDate && dateUtil.parseDate(reminderDate) > new Date());
        });
    }

    function reviewLater() {
        cm.showUnreviewedHotels = false;
        const dt = dateUtil.todayPlus(0, TRPCONFIG.Domain.ReviewReminderHours, true);
        preferences.set('reviewReminder', dt);
        scrollService.scrollTo('#reviews-container');
    }

    function reviewNow() {
        $location.path(`review-hotel/${cm.selectedHotel.BookingDetail.BookingId}`);
    }

    function cancelReview() {
        $location.path('dashboard/reviews');
    }

    function selectVisitedHotel(index) {
        cm.selectedHotel = cm.unreviewedHotels[index];
        cm.selectedHotelIndex = index;
    }
}
})();
